import React, { FC } from 'react'
import classNames from 'classnames'
import ProjectConstants from '../../../app/utlis/projectConstants'
import { getImage } from '../../../app/utlis/imageConstants'
import DynamicSVG from '../../atoms/DynamicSvg/DynamicSvg'

interface SaasIdeaProjectsProps {
    saasSoftwareData: any
}

const SaasIdeaProjects:FC<SaasIdeaProjectsProps> = ({saasSoftwareData}) => {
    return (
        <div className='flex flex-col gap-12 pt-12 bg-darkGreyPrimary justify-center items-center'>
            {saasSoftwareData.SaaSSoftwareIdeaProjectsData.map((projects:any) => {
                 let img = getImage(projects.image ?? "") ?? "";
                return (
                    <div className='bg-blackDark p-8 px-24'>
                        <div className={`flex-${projects.row} flex gap-10  bg-blackDark`}>
                            <div className={` bg-darkGreyPrimary w-2/6 h-auto rounded-full p-[30px]`}>
                             <DynamicSVG size='w-full h-full'>{img}</DynamicSVG>
                            </div>
                            <div className={classNames('flex flex-col w-2/4', `flex-${projects.row}`)}>
                                <div className={classNames('font-semibold text-4xl', `text-${projects.textColor}`)} >{projects.title}</div>
                                <div className={classNames('text-greyQuaternary text-lg pt-1 pb-10', `text-${projects.text}`)}>{projects.subtitle}</div>
                                <div className={`grid grid-cols-2 justify-between bg-darkGreyPrimary p-2`}>
                                    <div className={`p-4 font-bold text-xl relative overflow-hidden border border-${projects.textColor} border-l-[7px]`}>Business analysis</div>
                                    <div className={`p-4 font-bold text-xl relative overflow-hidden border border-[#292929]`}>Business analysis</div>
                                    <div className={`p-4 font-bold text-xl relative overflow-hidden border border-[#292929]`}>Business analysis</div>
                                    <div className={`p-4 font-bold text-xl relative overflow-hidden border border-[#292929]`}>Business analysis</div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}

        </div>
    )
}

export default SaasIdeaProjects
